<ng-template *ngIf="phone; then phoneTrue else phoneFalse"></ng-template>
<ng-template #phoneTrue>
  <a class="lisitng-phone-label" title="{{phone}}" target="_blank"
    href="https://api.whatsapp.com/send/?phone={{phone?.replace('+', '%2B')}}&text&type=phone_number&app_absent=0">
    {{(phone) ? (phone.length > 13)  ? phone.slice(0, 12) + '...' : phone.slice(0, 13) : ''}}
  </a>
</ng-template>
<ng-template #phoneFalse>
  <div class="opacity-50 fs-075r">No Telefono</div>
</ng-template>